import { ObservableArray, View } from "binder"
import { RequestingViewModel, StatusEnum, singleRequest } from "./requesting-viewModel"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";

export class RequestingView extends View<RequestingViewModel>{
    GetViewUniqueId(): string {
        return "V-C655338C-72FF-4A99-B00C-010DE05702C9"
    }
    loadHtml(): string {
        let element = require('./requesting.html').default;
        let style = require('./requesting.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set statusEnumProvider(v: StatusEnum) { this._statusEnumProvider = v; } public get statusEnumProvider(): StatusEnum { return this._statusEnumProvider;} private _statusEnumProvider: StatusEnum;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set items(v: ObservableArray<singleRequest>) { this._items = v; } public get items(): ObservableArray<singleRequest> { return this._items;} private _items: ObservableArray<singleRequest>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    public set amount(v: number) { this._amount = getAsNumber(v,true); } public get amount(): number { return this._amount;} private _amount: number;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set districtSelector(v: DistrictSelectorViewModel) { this._districtSelector = v; } public get districtSelector(): DistrictSelectorViewModel { return this._districtSelector;} private _districtSelector: DistrictSelectorViewModel;
    create(){
        this.dataContext.create();
    }
}
